import * as React from 'react';

import CheckmarkBadge16 from './CheckmarkBadge16';

export const checkmarkBadge16 = () => <CheckmarkBadge16 />;

export default {
    title: 'Icon/Line/CheckmarkBadge16',
    component: CheckmarkBadge16,
    parameters: {
        notes: "`import CheckmarkBadge16 from 'box-ui-elements/es/icon/line/CheckmarkBadge16';`",
    },
};
